/**
 * id -> id of a particular record (used mostly to send to backend)
 * name -> constant name given to a particular type(to increase readability of the code)
 * label -> name to display in the UI
 */

// eslint-disable-next-line import/no-extraneous-dependencies
import orderConstants from '@common/constants/orderConstants';
import { sourceAndDestinationType } from 'pando-constants';

export const unloadersList = [
  { id: 0, label: 'Yes', tlabel: 'INDENT_YES', value: true },
  { id: 1, label: 'No', tlabel: 'INDENT_NO', value: false },
];

export const paidByList = [
  { id: 0, label: 'Yes', tlabel: 'INDENT_YES', value: true },
  { id: 1, label: 'No', tlabel: 'INDENT_NO', value: false },
];

export const freightTypeList = [
  { id: 0, label: 'EX-Works', tlabel: 'INDENT_EX_WORKS', value: 0 },
  { id: 1, label: 'Party Collect', tlabel: 'INDENT_PARTY_COLLECT', value: 1 },
];

export const deliveryTypes = [
  { id: 'FTL', label: 'FTL', tlabel: 'INDENT_FTL' },
  { id: 'PTL', label: 'PTL', tlabel: 'INDENT_PTL' },
];

export const indentTypes = [{
  id: 0,
  name: orderConstants.OUTBOUND,
  label: 'Outbound',
  tlabel: 'INDENT_OUTBOUND',
},
{
  id: 1,
  name: orderConstants.INBOUND,
  label: 'Inbound',
  tlabel: 'INDENT_INBOUND',
}];

export const orderTypes = [
  {
    name: orderConstants.CONTRACT,
    id: 0,
    view_permission: 'view_contract_indent',
    create_permission: 'create_contract_indent',
    update_permission: 'update_contract_indent',
    label: 'Contract',
    tlabel: 'INDENT_CONTRACT',
    iconName: 'status_contract',
    dropoffs_columns_config: {
      hide_unloaders: true,
      hide_paid_by: true,
      hide_expected_date: true,
    },
  },
  {
    name: orderConstants.OPEN,
    id: 1,
    view_permission: 'view_open_indent',
    create_permission: 'create_open_indent',
    update_permission: 'update_open_indent',
    label: 'Open',
    tlabel: 'INDENT_OPEN',
    iconName: 'status_open',
  },
  {
    name: orderConstants.NO_FREIGHT,
    id: 2,
    view_permission: 'view_no_freight_indent',
    create_permission: 'create_no_freight_indent',
    update_permission: 'update_no_freight_indent',
    label: 'No Freight',
    tlabel: 'INDENT_NO_FREIGHT',
    iconName: 'status_nofreight',
  },
  {
    name: orderConstants.MARKET,
    id: 3,
    view_permission: 'view_market_indent',
    create_permission: 'create_market_indent',
    update_permission: 'update_market_indent',
    label: 'Market',
    tlabel: 'INDENT_MARKET',
    iconName: 'status_market',
  },
];

export const paymentTerms = [
];
export const freightTerms = [
  {
    id: 0,
    name: 'Shipper',
    key: 'shipper',
  },
  {
    id: 1,
    name: 'Customer',
    key: 'customer',
  },
];
export const terms = [
  {
    id: 0,
    name: 'EXW',
    key: 'EXW',
  },
  {
    id: 1,
    name: 'FCA',
    key: 'FCA',
  },
  {
    id: 2,
    name: 'CPT',
    key: 'CPT',
  },
  {
    id: 3,
    name: 'CIP',
    key: 'CIP',
  },
  {
    id: 4,
    name: 'DAP',
    key: 'DAP',
  },
  {
    id: 5,
    name: 'DPU',
    key: 'DPU',
  },
  {
    id: 6,
    name: 'DDP',
    key: 'DDP',
  },
  {
    id: 7,
    name: 'FAS',
    key: 'FAS',
  },
  {
    id: 8,
    name: 'FOB',
    key: 'FOB',
  },
  {
    id: 9,
    name: 'CFR',
    key: 'CFR',
  },
  {
    id: 10,
    name: 'CIF',
    key: 'CIF',
  },

];


export const CreateConfig = {
  OUTBOUND: {
    source: [
      {
        label: 'Depot',
        tlabel: 'INDENT_DEPOT',
        type: sourceAndDestinationType.DEPOT,
        hasGates: true, // i.e has gates
        storeCallPath: 'indentV2/getAssociatedDepots', // store.$dispatch method
        noPaginate: true, // to avoid adding page parameter to the api calls
        iconName: 'icon-source',
        GAEventConstants: ['Click', 'Source Depot'],
      },
      {
        label: 'Consignee',
        tlabel: 'INDENT_CONSIGNEE',
        type: sourceAndDestinationType.CONSIGNEE,
        storeCallPath: 'indentV2/getConsignees',
        disableOnSelect: [sourceAndDestinationType.VENDOR_DEPOT],
        iconName: 'icon-consignee',
        permission: 'inboundConfig.return_flow',
        GAEventConstants: ['Click', 'Source Consignee'],
      },
    ],
    destination: [
      {
        label: 'Depot',
        tlabel: 'INDENT_DEPOT',
        type: sourceAndDestinationType.DEPOT,
        storeCallPath: 'indentV2/getDepotsByType',
        GAEventConstants: ['Click', 'Destination Depot'],
      },
      {
        label: 'Consignee',
        tlabel: 'INDENT_CONSIGNEE',
        type: sourceAndDestinationType.CONSIGNEE,
        addOnCreate: true, // create consignee during the creation of indent
        feature: 'abc',
        storeCallPath: 'indentV2/getConsignees',
        GAEventConstants: ['Click', 'Destination Consignee'],
      },
    ],
  },
  INBOUND: {
    source: [
      {
        label: 'Consignee',
        tlabel: 'INDENT_CONSIGNEE',
        type: sourceAndDestinationType.CONSIGNEE,
        storeCallPath: 'indentV2/getConsignees',
        disableOnSelect: [sourceAndDestinationType.VENDOR_DEPOT],
        iconName: 'icon-consignee',
        permission: 'inboundConfig.return_flow',
        GAEventConstants: ['Click', 'Source Consignee'],
      },
      {
        label: 'Vendor depot',
        tlabel: 'INDENT_VENDOR_DEPOT',
        type: sourceAndDestinationType.VENDOR_DEPOT,
        hasGates: true, // i.e has gates
        disableOnSelect: [sourceAndDestinationType.CONSIGNEE],
        storeCallPath: 'indentV2/getDepotsByType',
        iconName: 'icon-vendor-depot',
        permission: 'inboundConfig.vendor_flow',
        GAEventConstants: ['Click', 'Source Vendor Depot'],
      },
    ],
    destination: [
      {
        label: 'Depot',
        tlabel: 'INDENT_DEPOT',
        type: sourceAndDestinationType.DEPOT,
        storeCallPath: 'indentV2/getDepotsByType',
        GAEventConstants: ['Click', 'Destination Depot'],
      },
    ],
  },
};

export const numberOfVehicles = {
  min: 1,
  max: 10,
};


export const mandatoryConsigneeFields = ['name', 'reference_id', 'city', 'state', 'region', 'pincode'];

export const indentUpdateOptions = [{
  value: 'Truck type not available with transporter',
  key: 'TRUCK_TYPE_NOT_AVAILABLE',
},
{
  value: 'Transporter not available',
  key: 'TRANSPORTER_NOT_AVAILABLE',
},
{
  value: 'Transporter not responsive',
  key: 'TRANSPORTER_NOT_RESPONSIVE',
},
{
  value: 'Others',
  key: 'OTHERS',
},
];
